import { useState } from "react";

import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "navbars/DashboardNavbar";
import MDBox from "components/MDBox";

import AddTask from "./AddTask";
import ListTasks from "./ListTask";

const Task = () => {
  const [refreshTasks, setRefreshTasks] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const handleCancelEdit = () => {
    setTaskToEdit(null); 
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Tareas pendientes" />
      <AddTask
        taskToEdit={taskToEdit}
        onAddTask={() => setRefreshTasks((prev) => !prev)}
        onCancelEdit={handleCancelEdit}
      ></AddTask>
      <MDBox pt={3}>
        <ListTasks refreshTasks={refreshTasks} onEdit={(task) => setTaskToEdit(task)}></ListTasks>
      </MDBox>
    </DashboardLayout>
  );
};

export default Task;
